import { render, staticRenderFns } from "./KioskLayout.vue?vue&type=template&id=bf1eb6c2&scoped=true"
import script from "./KioskLayout.vue?vue&type=script&lang=ts"
export * from "./KioskLayout.vue?vue&type=script&lang=ts"
import style0 from "./KioskLayout.vue?vue&type=style&index=0&id=bf1eb6c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1eb6c2",
  null
  
)

export default component.exports